var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',_vm._g(_vm._b({ref:"rockTableTree",scopedSlots:_vm._u([{key:"operate",fn:function({ row }){return [_vm._t("operate",null,{"row":row})]}}],null,true)},'vxe-grid',_vm.gridOptions,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }